/* NB-024-AB */
(function () {
  var root = document.querySelector('[data-task="NB-024-AB"]');
  if (!root) return;

  var host = root.closest('.shopify-section') || root;
  var control = document.querySelector('[data-section-id="pf-93a2"]');

  if (!control) {
    var headings = document.querySelectorAll('h2, h3');
    for (var i = 0; i < headings.length; i++) {
      var label = (headings[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.indexOf('get started') === 0) {
        control = headings[i].closest('[data-section-id]');
        break;
      }
    }
  }

  if (!control || !control.parentNode || host === control) return;
  control.parentNode.insertBefore(host, control);
})();
